import React from 'react';

import { AnnotationsContent } from 'components/ChartTools/Annotations';

import { useScreenDispatch } from '@gogame/screens';

import {
  useChartIndex,
  useChartState,
} from 'scenes/Trackers/Tracker/components/TrackerCharts/Chart/hooks';
import {
  HIDE_CHART_ANNOTATIONS,
  SHOW_CHART_ANNOTATIONS,
} from 'scenes/Trackers/Tracker/reducers';

export const AnnotationSidebar = ({ items, period, id }) => {
  const chartState = useChartState();
  const dispatch = useScreenDispatch();
  const chartIndex = useChartIndex();
  const chartType = chartState.chartViewSettings.type;

  const handleShowAnnotations = (value) => {
    dispatch({
      type: SHOW_CHART_ANNOTATIONS,
      payload: {
        index: chartIndex,
        value,
      },
    });
  };

  const handleHideAnnotations = () => {
    dispatch({
      type: HIDE_CHART_ANNOTATIONS,
      payload: {
        index: chartIndex,
      },
    });
  };

  if (chartType === 'pie') {
    return null;
  }

  return (
    <AnnotationsContent
      onShow={handleShowAnnotations}
      onHide={handleHideAnnotations}
      settings={chartState.annotations}
      items={items}
      period={period}
      id={id}
    />
  );
};
